export const GET_KEYWORDS = 'GET_KEYWORDS';
export const SET_KEYWORDS = 'SET_KEYWORDS';
export const ERROR_KEYWORDS = 'ERROR_KEYWORDS';